import { Model } from "@vuex-orm/core";
import Customer from "./Customer";

export default class Address extends Model {
  static entity = "addresses";

  static fields() {
    return {
      createdAt: this.attr(),
      updatedAt: this.attr(),
      id: this.attr(),
      isDirty: this.boolean(false),
      customerId: this.number(0),
      type: this.string("main"),
      address1: this.attr(),
      address2: this.attr(),
      city: this.attr(),
      state: this.attr(),
      postalCode: this.attr(),
      customer: this.belongsTo(Customer, "customerId")
    };
  }

  get fullAddress() {
    return [
      this.address1 || this.address2
        ? [this.address1, this.address2].join(" ").trim() + ","
        : null,
      this.city ? this.city + "," : null,
      this.state,
      this.postalCode
    ].join(" ");
  }

  static mutators() {
    return {
      createdAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      },
      updatedAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      }
    };
  }
}
